// extracted by mini-css-extract-plugin
export default {"permisos":"PermisosDeReparticion_permisos__Daq4x","casillas":"PermisosDeReparticion_casillas__QqFeO"};